import { Link } from "react-router-dom";
import { SERVICES } from "@/data/services";
import { ArrowRight } from "@phosphor-icons/react";

export default function ServicesPage() {
  return (
    <div data-testid="services-page">
      <section className="relative bg-zinc-50 border-b border-zinc-200 overflow-hidden ruler-top">
        <div className="absolute inset-0 bg-blueprint-grid pointer-events-none" aria-hidden="true" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-14 md:pb-20">
          <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-[#0044FF] mb-4">
            Services · 13 deliverables
          </div>
          <h1 className="font-display text-5xl md:text-7xl tracking-tighter font-medium text-zinc-950 max-w-4xl leading-[0.95]">
            Land surveying CAD drafting — the complete catalog.
          </h1>
          <p className="mt-6 text-lg text-zinc-600 max-w-2xl leading-relaxed">
            Pick the survey type you need. Each page lists the exact documents and data we
            require to deliver a sealed-ready drawing.
          </p>
        </div>
      </section>

      <section className="bg-zinc-50 py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-zinc-200 border border-zinc-200">
            {SERVICES.map((s, idx) => (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                className="group bg-white p-8 md:p-9 hover:bg-zinc-50 transition-colors"
                data-testid={`services-card-${s.slug}`}
              >
                <div className="flex items-start justify-between">
                  <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-400">
                    FIG {String(idx + 1).padStart(2, "0")}
                  </span>
                  <ArrowRight
                    size={16}
                    weight="bold"
                    className="text-zinc-300 group-hover:text-[#0044FF] group-hover:translate-x-1 transition-all"
                  />
                </div>
                <h3 className="mt-6 font-display text-2xl text-zinc-950 tracking-tight leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-zinc-600 leading-relaxed">
                  {s.short}
                </p>
                <ul className="mt-5 pt-4 border-t border-dashed border-zinc-200 space-y-1">
                  {s.deliverables.slice(0, 3).map((d) => (
                    <li
                      key={d}
                      className="text-[12px] font-mono text-zinc-500 flex gap-2"
                    >
                      <span className="text-[#0044FF]">▸</span>
                      {d}
                    </li>
                  ))}
                </ul>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
